export enum FIELD_VALUES {
  APPLICANT_ESTIMATE = 'APPLICANT_ESTIMATE',
  AUSTRALIAN_CITIZEN = 'AUSTRALIAN_CITIZEN',
  AVERAGE = 'AVERAGE',
  BOARDING = 'Boarding',
  /**
   * @deprecated not used
   */
  BORROW_AND_GUARANTOR = 'BORROW_AND_GUARANTOR',
  BORROWER = 'BORROWER',
  BORROWING_POWER = 'BORROWING_POWER',
  BUYING_SOON = 'BUYING_SOON',
  CAR_LOAN = 'CAR_LOAN',
  CARAVAN = 'Caravan',
  CASUAL = 'CASUAL',
  CASH_MANAGEMENT_TRUST = 'CASH_MANAGEMENT_TRUST',
  COMMERCIAL = 'COMMERCIAL',
  COMPANY = 'COMPANY',
  COMPLETE = 'COMPLETE',
  CONSOLIDATE_CASHOUT = 'CONSOLIDATE_CASHOUT',
  CONSTRUCTION = 'CONSTRUCTION',
  CONSTRUCTION_LOAN = 'CONSTRUCTION_LOAN',
  CONTRACTOR = 'CONTRACTOR',
  CONTRACTS_EXCHANGED = 'CONTRACTS_EXCHANGED',
  CREDIT_CARD = 'CREDIT_CARD',
  DE_FACTO = 'DE_FACTO',
  DECREASE_REPAYMENTS = 'DECREASE_REPAYMENTS',
  DEPOSIT = 'DEPOSIT',
  DECEASED = 'DECEASED',
  DIRECTOR = 'DIRECTOR',
  DISCRETIONARY_TRUST = 'DISCRETIONARY_TRUST',
  DIVORCED = 'DIVORCED',
  DR = 'DR',
  DUPLEX = 'DUPLEX',
  EMPLOYEE = 'EMPLOYEE',
  EQUAL = 'EQUAL',
  ESTABLISHED = 'ESTABLISHED',
  EXCELLENT = 'EXCELLENT',
  EXPLORING_OPTIONS = 'EXPLORING_OPTIONS',
  FAIR = 'FAIR',
  FALSE = 'FALSE',
  FASTER_PAYOFF = 'FASTER_PAYOFF',
  FEMALE = 'FEMALE',
  FIXED = 'FIXED',
  FIXED_RATE = 'FIXED_RATE',
  FULL_TIME = 'FULL_TIME',
  FULLY_DETACHED_HOUSE = 'FULLY_DETACHED_HOUSE',
  GUARANTOR = 'GUARANTOR',
  HELP_HECS_DEBT = 'HELP_HECS_DEBT',
  HOME_LOAN = 'HOME_LOAN',
  HOUSING_STATUS_OTHER = 'Other',
  HYBRID = 'HYBRID',
  IN_PROGRESS = 'IN_PROGRESS',
  INTEREST_ONLY = 'INTEREST_ONLY',
  INVESTMENT = 'INVESTMENT',
  KIT_HOME = 'KIT_HOME',
  LAND = 'LAND',
  LEASE_OR_HIRE_FINANCE = 'LEASE_OR_HIRE_FINANCE',
  LENDER_COMPLETE = 'LENDER_COMPLETE',
  LINE_OF_CREDIT = 'LINE_OF_CREDIT',
  LOAN_AFFORDABILITY = 'LOAN_AFFORDABILITY',
  LOAN_APPROVAL = 'LOAN_APPROVAL',
  LOAN_ELIGIBILITY = 'LOAN_ELIGIBILITY',
  MAJOR_LENDER = 'MAJOR_LENDER',
  MALE = 'MALE',
  MARRIED = 'MARRIED',
  MATERNITY_LEAVE = 'MATERNITY_LEAVE',
  MISS = 'MISS',
  MINOR_CONTRIBUTION = 'MINOR_CONTRIBUTION',
  MOBILE_APP = 'MOBILE_APP',
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
  MULTI_DWELLING_SINGLE_TITLE = 'MULTI_DWELLING_SINGLE_TITLE',
  MULTIPLE = 'MULTIPLE',
  NEW = 'NEW',
  NEW_BUILDING = 'NEW_BUILDING',
  NEW_PURCHASE = 'NEW_PURCHASE',
  NO = 'NO',
  NOT_SURE = 'NOT_SURE',
  NOT_URGENT = 'NOT_URGENT',
  NOT_WORKING = 'NOT_WORKING',
  OFFER_MADE = 'OFFER_MADE',
  OFFSET_OR_REDRAW = 'OFFSET_OR_REDRAW',
  OTHER = 'OTHER',
  OVERDRAFT = 'OVERDRAFT',
  OWN_HOME = 'Own Home',
  OWN_HOME_MORTGAGE = 'Own Home Mortgage',
  OWNER_OCCUPIED = 'OWNER_OCCUPIED',
  PARTNERSHIP = 'PARTNERSHIP',
  PART_TIME = 'PART_TIME',
  PAYING_OUT = 'PAYING_OUT',
  PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
  PERSON = 'PERSON',
  PERSONAL_LOAN = 'PERSONAL_LOAN',
  POST_SETTLEMENT_CURRENT_ADDRESS = 'CURRENT_ADDRESS',
  POST_SETTLEMENT_MAILING_ADDRESS = 'MAILING_ADDRESS',
  POST_SETTLEMENT_NEW_ADDRESS = 'NEW_ADDRESS',
  PREAPPROVAL = 'PREAPPROVAL',
  PREVIOUS = 'PREVIOUS',
  PRIMARY = 'PRIMARY',
  PRINCIPAL_AND_INTEREST = 'PRINCIPAL_AND_INTEREST',
  PRODUCT_COMPLETE = 'PRODUCT_COMPLETE',
  PROPERTY_OVER_10HA = 'PROPERTY_OVER_10_HA',
  REAL_ESTATE = 'REAL_ESTATE',
  REDUCING = 'REDUCING',
  REFINANCE = 'REFINANCE',
  RENTING = 'Renting',
  RESIDENTIAL = 'RESIDENTIAL',
  SECONDARY = 'SECONDARY',
  SECURITY_PROPERTY = 'SECURITY_PROPERTY',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  SELF_EMPLOYED_LOW_DOC = 'SELF_EMPLOYED_LOW_DOC',
  SEMI_DETACHED_HOUSE = 'SEMI_DETACHED_HOUSE',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  SHORT_TERM_FINANCE = 'SHORT_TERM_FINANCE',
  SINGLE = 'SINGLE',
  SIMPLE_OR_BARE = 'SIMPLE_OR_BARE',
  SOLE_TRADER = 'SOLE_TRADER',
  SPECIFIED = 'SPECIFIED',
  STILL_DECIDING = 'STILL_DECIDING',
  STORE_CARD = 'STORE_CARD',
  STUDENT_ACCOMMODATION = 'STUDENT_ACCOMMODATION',
  STUDIO = 'STUDIO',
  SUPERANNUATION_TRUSTS = 'SUPERANNUATION_TRUSTS',
  SUPPLIED_BY_EMPLOYER = 'Supplied by Employer',
  TAX_DEBT = 'TAX_DEBT',
  TEMPORARY_RESIDENT = 'TEMPORARY_RESIDENT',
  TERRACE = 'TERRACE',
  TOP_UP = 'TOP_UP',
  TOWNHOUSE = 'TOWNHOUSE',
  TRUE = 'TRUE',
  TRUST = 'TRUST',
  TRUSTEE = 'TRUSTEE',
  UNDISCLOSED = 'UNDISCLOSED',
  UNIT = 'UNIT',
  UNIT_LESS_THAN_50M2 = 'APARTMENT_UNIT_LESS_THAN_50M2',
  UNIT_MORE_THAN_50M2 = 'APARTMENT_UNIT_MORE_THAN_50M2',
  UNKNOWN = 'UNKNOWN',
  URGENT = 'URGENT',
  VACANT_LAND = 'VACANT_LAND',
  VARIABLE = 'VARIABLE',
  VEHICLE = 'VEHICLE',
  VILLA = 'VILLA',
  WAREHOUSE_APARTMENT = 'WAREHOUSE_APARTMENT',
  WITH_PARENTS = 'With Parents',
  YES = 'YES',
  DIRECT_DEBIT_NEW_ACCOUNT = 'DIRECT_DEBIT_NEW_ACCOUNT',
  DIRECT_DEBIT_EXISTING_ACCOUNT = 'DIRECT_DEBIT_EXISTING_ACCOUNT',
  DIRECT_CREDIT = 'DIRECT_CREDIT',
  MANUAL_REPAYMENTS = 'MANUAL_REPAYMENTS',
}
